import {Box, Typography} from "@mui/material";

export default function EmptyState({icon, title, description, action}) {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            gap: 1,
            py: 5,
            px: 3,
            width: '100%',
        }}>
            {icon && (
                <Box sx={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    backgroundColor: 'action.hover',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'primary.main',
                    marginBottom: 0.5,
                    '& .MuiSvgIcon-root': {fontSize: 28},
                }}>
                    {icon}
                </Box>
            )}
            <Typography sx={{fontSize: 16, fontWeight: 500, color: 'text.primary'}}>{title}</Typography>
            {description && (
                <Typography sx={{fontSize: 13, color: 'text.secondary', maxWidth: 360}}>{description}</Typography>
            )}
            {action && <Box sx={{marginTop: 1}}>{action}</Box>}
        </Box>
    );
}
